'use strict';

var format = require('date-fns/format');
var getMonth = require('date-fns/getMonth');
var getYear = require('date-fns/getYear');
var locale = require('date-fns/locale');
var index = require('../../DateInput/constants/index.js');

const getISODate = (date) => format.formatDate(date, 'yyyy-MM-dd');
const getDateFormatted = (date, dateFormat = 'dd.MM.yyyy', locale$1 = locale.ru) => format.formatDate(date, dateFormat, { locale: locale$1 });
const getDayFormatted = (date) => format.formatDate(date, 'd');
const getMonthFormatted = (date) => `${index.MONTHS[getMonth.getMonth(date)]} ${getYear.getYear(date)}`;

exports.getDateFormatted = getDateFormatted;
exports.getDayFormatted = getDayFormatted;
exports.getISODate = getISODate;
exports.getMonthFormatted = getMonthFormatted;
//# sourceMappingURL=date.js.map
